import styled from 'styled-components/macro';

const TransitionGroupContainer = styled.div`
    display: flex;
    flex: 1;
    position: relative;
`;

export default TransitionGroupContainer;
